import { Button } from "@/components/ui/button";
import { LayoutDashboard } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const AdminButton = () => {
  const navigate = useNavigate();
  
  return (
    <Button 
      variant="outline"
      onClick={() => navigate("/admin")}
      size="icon"
      title="لوحة التحكم"
    >
      <LayoutDashboard className="w-4 h-4" />
    </Button>
  );
};